export default "__VITE_ASSET__D89AcylE__"